import { Attribute, AttributePreview } from 'src/api/v1-api';

export const resolveAttributeSource = (
  categoryAttributes: Attribute[] | AttributePreview[] | undefined,
  fallback: Attribute[],
): Attribute[] => {
  if (!Array.isArray(categoryAttributes) || categoryAttributes.length === 0) {
    return fallback;
  }

  const [firstAttribute] = categoryAttributes;

  if (firstAttribute && 'id' in firstAttribute) {
    return categoryAttributes as Attribute[];
  }

  return fallback;
};
